import { useCallback, useState } from 'react';
import {
  formatEvidenceTimestamp,
  getLocalTimezoneLabel,
  getTimezoneMode,
  setTimezoneMode,
} from '../utils/evidenceTime';

export default function useEvidenceTimezone() {
  const [mode, setModeState] = useState(() => getTimezoneMode());
  const localLabel = getLocalTimezoneLabel();

  const setMode = useCallback((next) => {
    const value = next === 'gmt' ? 'gmt' : 'local';
    setTimezoneMode(value);
    setModeState(value);
  }, []);

  const format = useCallback(
    (isoString) => formatEvidenceTimestamp(isoString, mode),
    [mode],
  );

  const suffix = mode === 'gmt' ? 'UTC' : localLabel;

  return {
    mode,
    setMode,
    format,
    localLabel,
    suffix,
  };
}
